import { createI18n } from 'vue-i18n'
import en from './locales/en'
import zh from './locales/zh'

// Get saved language or default to English
const getDefaultLanguage = (): string => {
    const saved = localStorage.getItem('kernelpilot-lang')
    if (saved && ['en', 'zh'].includes(saved)) {
        return saved
    }
    // Default to English
    return 'en'
}

const i18n = createI18n({
    legacy: false,
    locale: getDefaultLanguage(),
    fallbackLocale: 'en',
    messages: {
        en,
        zh
    }
})

export default i18n

// Helper function to change language
export const setLanguage = (lang: string) => {
    if (['en', 'zh'].includes(lang)) {
        i18n.global.locale.value = lang as 'en' | 'zh'
        localStorage.setItem('kernelpilot-lang', lang)
        document.documentElement.setAttribute('lang', lang)
    }
}

// Helper function to get current language
export const getCurrentLanguage = (): string => {
    return i18n.global.locale.value
}
